import { render, staticRenderFns } from "./trainingModulePageInformationImage2.vue?vue&type=template&id=45758afe&scoped=true&"
import script from "./trainingModulePageInformationImage2.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageInformationImage2.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageInformationImage2.vue?vue&type=style&index=0&id=45758afe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45758afe",
  null
  
)

export default component.exports